import { InvoiceItemTypes } from '../enums';

export class InvoiceItemType {
    description: string;

    id: InvoiceItemTypes;
}
